export const ACTION_ERROR_MESSAGE = $localize`Sorry, something went wrong. Please try again.`;

export const PASSWORD_RESET_EMAIL_SENT_MESSAGE = $localize`The password reset email has been sent.`;
